import TextInputAtom from '../TextInputAtom/textInputAtom';
import InputWrapper from '../inputWrapper.tsx';
import { InputState, TextInputTypes } from '../../../util/types';
import React, { forwardRef } from 'react';

export interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  state?: InputState;
  type?: TextInputTypes;
  label: string;
  optionalityLabel?: string;
  helpText?: string[];
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  message?: string;
  className?: string;
  hasMarginBottom?: boolean;
}

const TextInput = forwardRef(
  (
    {
      id,
      state = 'default' as InputState,
      disabled = false,
      type = 'text' as TextInputTypes,
      label,
      optionalityLabel = '',
      helpText = [],
      message = '',
      className = '',
      hasMarginBottom = true,
      onBlur,
      ...props
    }: TextInputProps,
    ref: React.Ref<HTMLInputElement>
  ) => {
    return (
      <InputWrapper
        id={id}
        state={state}
        disabled={disabled}
        label={label}
        optionalityLabel={optionalityLabel}
        helpText={helpText}
        message={message}
        className={className}
        hasMarginBottom={hasMarginBottom}
        child={
          <TextInputAtom
            id={id}
            aria-labelledby={label ? 'label_' + id : undefined}
            aria-describedby={
              helpText && helpText.length > 0 ? 'helptext_' + id : undefined
            }
            type={type}
            state={state}
            disabled={disabled}
            ref={ref}
            onBlur={onBlur}
            {...props}
          />
        }
      />
    );
  }
);

export default TextInput;
